'use client'

import type { Workspace } from '@botpress/client'

import type { User } from '~/features/users/types'
import { useAppStore } from '../../stores'
import { UserDropdown } from './UserDropdown'
import { Avatar } from '~/elements'

export function NavUser({ workspaces }: { workspaces: Workspace[] }) {
  const activeWorkspace = useAppStore((s) => s.activeWorkspace)
  const user = useAppStore((s) => s.currentUser)

  const userHasAccessToWorkspace = workspaces.some((w) => w.id === activeWorkspace?.id)

  return (
    <UserDropdown disabled={!user} user={user as User} asChild hasAccessToWorkspace={userHasAccessToWorkspace}>
      <Avatar
        name={user?.displayName || user?.email}
        pictureUrl={user?.profilePicture}
        className="h-7 w-7 rounded-full hover:cursor-pointer sm:h-8 sm:w-8"
        variant="solid"
      />
    </UserDropdown>
  )
}
